export default __webpack_public_path__ + "/dist/images/buyer-global-map.fe7a0621b3cebc33ef48ecddf48ff221.jpg";